// 菜单层级
export const menus_config = [
  {
    path: '/check_organization',
    name: '检测机构管理',
    children: [
      {
        path: '/o_checker',
        name: '检测机构信息管理',
      },
      {
        path: '/o_checker_card',
        name: '检测机构资质管理',
      },
      {
        path: '/professer',
        name: '检测机构评审专家库',
      },
      {
        path: '/db_check',
        name: '检测机构双随机检查任务下发',
      },
      {
        path: '/db_check_info',
        name: '检测机构双随机检查',
      },
    ],
  },
  {
    path: '/risk_monotoring',
    name: '风险监测管理',
    children: [
      {
        path: '/plan_manager',
        name: '监测方案发布',
      },
      {
        path: '/project_management',
        name: '监测项目管理',
      },
      {
        path: '/pick_management',
        name: '抽样管理',
      },
      {
        path: '/check_manager',
        name: '检测管理',
      },
      {
        path: '/pick_check_management',
        name: '抽样检测管理',
      },
      {
        path: '/finish_info',
        name: '检测任务完成情况',
      },
    ],
  },
  {
    path: '/basic_information',
    name: '基础信息管理',
    children: [
      {
        path: '/o_need_check',
        name: '受检单位管理',
      },
      {
        path: '/std_bad',
        name: '污染物信息管理',
      },
      {
        path: '/std_bad_dic',
        name: '污染物字典管理',
      },
      {
        path: '/std_judge',
        name: '判定标准管理',
      },
      {
        path: '/std_limit',
        name: '限量标准管理',
      },
      {
        path: '/std_produce',
        name: '农产品信息管理',
      },
      {
        path: '/o_manager',
        name: '管理单位信息管理',
      },
      {
        path: '/o_pick_tmpl',
        name: '抽样单模板管理',
      },
    ],
  },
    {
        path: '/system',
        name: '系统管理',
        children: [
            {
                path: '/system/user-manage',
                name: '用户管理',
            },
            {
                path: '/system/role-manage',
                name: '角色管理',
            },
        ],
    },
];

// 根据角色过滤后的菜单
var menus = [];

// 扁平化处理后的菜单
const menus_flattern = [];

import _ from 'lodash';
import store from '@/store';

// 根据角色获取过滤对应的菜单列表
export const getMenus = () => {
  menus = [];
  let menu_config_clone = _.cloneDeep(menus_config);
  // 遍历菜单，根据角色过滤出需要的菜单
  menu_config_clone.forEach((menu_sub) => {
    menus.push(menu_sub);
    // 如果有重叠，开始过滤其子节点
    menu_sub.children = menu_sub.children.filter((menu) => {
      // 判断角色之间是否存在重叠
      // let have_perm = havePerm(menu.path);
      // // 如果没有重叠，则该大菜单被过滤
      // if (!have_perm) {
      //   return true;
      // }
      // return true;

      // 判断当前登录用户的角色是否为机构，如果是则只能访问特定的3个界面，如果不是机构，则可以查看所有
      // 是个数组
      // if (store.getters.roles.includes('机构人员')) {
      //   // 判断当前的路由是否属于特定的3个界面，如果是，则可以访问
      //   if (['/pick_management', '/check_manager', '/pick_check_management'].includes(menu.path)) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   return true;
      // }
      //   if(store.state.user.perms.menu.includes(menu.path))
      //   {
      //       return true
      //   }
      //   else {
      //       return false
      //   }
        return true;
    });
  });
  menus = menus.filter((menu) => menu.children.length > 0);
  return menus;
};
const havePerm = (path) => {
  // 获取当前登录用户的角色
  let { menus } = store.getters;
  return menus.some((_path) => {
    return _path.path === path;
  });
};

// 构建扁平化菜单
export const getMenuFlattern = () => {
  const menus_reduce = _.cloneDeep(getMenus());
  // 将数组进行扁平化处理，并且添加其对应的父级path
  for (let menu_sub of menus_reduce) {
    if (menu_sub.hasOwnProperty('children')) {
      menu_sub.children.forEach((menu) => {
        menus_flattern.push({
          ...menu,
          ppath: menu_sub.path,
          breadcrumb: [menu_sub.name, menu.name],
        });
      });
    } else {
      menus_flattern.push({
        ...menu,
        breadcrumb: [menu_sub.name, menu.name],
      });
    }
  }
  return menus_flattern;
};

// 根据path查询到对应的菜单详细信息
export const getRouteInfo = (path) => {
  let menu = getMenuFlattern().find((menu) => menu.path === path);
  return menu;
};
